import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "@fontsource/roboto";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/300.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);
